var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 73.314C57.279 73.314 73.3135 57.2795 73.3135 37.5C73.3135 17.7205 57.279 1.68604 37.4995 1.68604C17.72 1.68604 1.68555 17.7205 1.68555 37.5C1.68555 57.2795 17.72 73.314 37.4995 73.314Z",
    fill: "#F25268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9439 23.0946C49.73 14.5428 37.5001 19.5877 37.5001 28.2713C37.5001 19.5863 25.2686 14.5399 19.0533 23.0931C12.6314 31.9334 18.9625 47.4227 37.5001 56.3202C56.0362 47.4227 62.3687 31.9335 55.9439 23.0946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.7481d1467058bf8534b210d9632f717b.svg";
export { ForwardRef as ReactComponent };